import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Plane, Users, MapPin, Gem, CalendarCheck } from "lucide-react";

const STEPS = [
  { icon: Plane, label: "Packing our bags…" },
  { icon: Users, label: "Consulting the locals…" },
  { icon: MapPin, label: "Scouting the best spots & food…" },
  { icon: Gem, label: "Uncovering hidden gems…" },
  { icon: CalendarCheck, label: "Plotting your day-by-day plan…" },
];

export const GenerationProgress = () => {
  const [step, setStep] = useState(0);
  const [pct, setPct] = useState(6);

  useEffect(() => {
    const stepTimer = setInterval(() => {
      setStep((s) => (s < STEPS.length - 1 ? s + 1 : s));
    }, 11000);
    const pctTimer = setInterval(() => {
      setPct((p) => (p < 94 ? p + Math.max(1, Math.round((94 - p) / 12)) : p));
    }, 900);
    return () => {
      clearInterval(stepTimer);
      clearInterval(pctTimer);
    };
  }, []);

  const Active = STEPS[step].icon;

  return (
    <div className="mt-16 max-w-lg mx-auto text-center" data-testid="plan-loading">
      <motion.div
        key={step}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 260, damping: 18 }}
        className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#1A3B2B] text-[#FDFBF7] mb-6"
      >
        <Active className="w-7 h-7" strokeWidth={1.75} />
      </motion.div>

      <motion.p
        key={`t-${step}`}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        className="font-display text-2xl mb-6"
        data-testid="plan-loading-step"
      >
        {STEPS[step].label}
      </motion.p>

      <div className="h-2 w-full rounded-full bg-[#F3EFE8] overflow-hidden">
        <motion.div
          className="h-full bg-[#C8553D]"
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />
      </div>
      <p className="mt-3 text-sm text-muted-foreground">{pct}% — good trips take a moment</p>

      <div className="mt-8 flex justify-center gap-2">
        {STEPS.map((s, i) => (
          <div
            key={i}
            className={`h-1.5 rounded-full transition-all duration-500 ${
              i <= step ? "w-8 bg-[#1A3B2B]" : "w-4 bg-[#E8E3D9]"
            }`}
          />
        ))}
      </div>
    </div>
  );
};
